export default {
  // Ids kept byte-identical to their old home in MetalDetail.translations.ts so the
  // translation catalog doesn't churn over a file move. (`metal_detail_sources` is not
  // carried across: the bibliography section it labelled is gone — sources now render
  // inline through `SourceMarker` — so it moved with nothing to move to.)
  topMiningCountries: {
    id: 'rm_metal_detail_top_mining_countries',
    defaultMessage: 'Top mining countries:',
  },
  whatItDoes: {
    id: 'rm_metal_detail_what_it_does',
    defaultMessage: 'What it does:',
  },
  extraction: {
    id: 'rm_metal_detail_extraction',
    defaultMessage: 'How it is extracted',
  },
  // Heads the scored pair. Id kept from its old home in `data/metals/sections.translations.ts`.
  keepUp: {
    id: 'rm_metal_section_keep_up',
    defaultMessage: 'Can we keep up?',
  },
  supplyRisk: {
    id: 'rm_metal_detail_supply_risk',
    defaultMessage: 'Supply risk',
  },
  recycling: {
    id: 'rm_metal_detail_recycling',
    defaultMessage: 'Recycling level',
  },
  // Labels the notes the client marks `*` / `**` through their sheets. Distinct from the
  // bibliography, which `SourceMarker` opens: a footnote is this metal's own caveat, and a
  // note may well cite the bibliography itself.
  footnotes: {
    id: 'rm_metal_detail_footnotes',
    defaultMessage: 'Footnotes:',
  },
  // Only this label is translated; the names are proper nouns authored on each photo.
  photoCredits: {
    id: 'rm_metal_detail_photo_credits',
    defaultMessage: 'Image credits:',
  },
} as const
